import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { MessageBusEvents } from 'common/common/constants/message-bus-events';
import { RxEmitter } from 'common/rxjs/rx-emitter';
import { ChatMessagesQueueService } from 'common/chat-messages-queue/chat-messages-queue.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-pending-messages',
  templateUrl: './pending-messages.component.html',
  styleUrls: ['./pending-messages.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PendingMessagesComponent implements OnInit, OnDestroy {
  @Input()
  workItemId: string;

  @Output()
  closeHandler = new EventEmitter<void>();

  public isOpened: boolean;
  public areMessagesShown: boolean = false;
  public pendingMessages = [];

  private _pendingMessagesSubscription: Subscription;
  private _messagesQueueClearedSubscription: Subscription;

  constructor(private _rxEmitter: RxEmitter, private _chatMessagesQueueService: ChatMessagesQueueService) {
    this.pendingMessages = this._chatMessagesQueueService.getChatMessagesInQueue(this.workItemId);
    this.isOpened = this.pendingMessages.length > 0;
  }

  ngOnInit(): void {
    this._pendingMessagesSubscription = this._rxEmitter.subscribe(`${MessageBusEvents.PendingChatMessages}${this.workItemId}`, () => {
      this.pendingMessages = this._chatMessagesQueueService.getChatMessagesInQueue(this.workItemId);

      if (!this.isOpened) {
        this.isOpened = true;
      }
    });

    this._messagesQueueClearedSubscription = this._rxEmitter.subscribe(`${MessageBusEvents.ChatMessagesQueueCleared}${this.workItemId}`, () => {
      this.pendingMessages = [];
      this.areMessagesShown = false;
      this.isOpened = false;
    });
  }

  ngOnDestroy(): void {
    if (this._pendingMessagesSubscription) {
      this._pendingMessagesSubscription.unsubscribe();
      this._pendingMessagesSubscription = null;
    }

    if (this._messagesQueueClearedSubscription) {
      this._messagesQueueClearedSubscription.unsubscribe();
      this._messagesQueueClearedSubscription = null;
    }
  }

  public get isPanelOpened() {
    return this.isOpened && this.pendingMessages.length > 0;
  }

  public getPendingMessagesLabel(): string {
    return this.pendingMessages.length > 1 ? 'pendingMessages.sendingMessages' : 'pendingMessages.sendingMessage';
  }

  public getToggleDetailsLabel(): string {
    return this.areMessagesShown ? 'pendingMessages.hideDetails' : 'pendingMessages.showDetails';
  }

  public onToggleDetailsClick(): void {
    this.areMessagesShown = !this.areMessagesShown;
  }

  public onDeleteMessageFromQueueClick(messageIndex: number): void {
    this._chatMessagesQueueService.deleteChatMessageFromQueue(this.workItemId, messageIndex);
  }
}
